import { render, staticRenderFns } from "./AgeFilter.vue?vue&type=template&id=59824af4&"
import script from "./AgeFilter.vue?vue&type=script&lang=js&"
export * from "./AgeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports